import React from 'react';
import {Checkbox} from "@/components/ui/checkbox";
import Spinner from "@/components/ui/loading/Spinner";
import {BrandListProps, FilterBrandProps} from "@/interface/components/brands";


const BrandList = ({brands, lastBrandElementRef, handleBrandSelect, selectedBrands, loading}: BrandListProps) => {
    return (
        <section className={"border border-[#EBEBEB] rounded-xl pt-3"}>
            <h6 className={"text-xs text-past-price font-medium leading-4 px-3 pb-2"}>همه ی برند ها</h6>
            <div
                className="max-h-[266px] overflow-y-auto scroll-custom flex flex-wrap content-start justify-between px-3">
                {brands.map((brand: FilterBrandProps, index: number) => {
                    const isLastElement = index === brands.length - 1;

                    return (
                        <div
                            key={index}
                            ref={isLastElement ? lastBrandElementRef : null}
                            className="w-full flex flex-wrap items-center cursor-pointer"
                            onClick={() => handleBrandSelect(Number(brand?.id))}
                        >
                            <Checkbox
                                id={`brand-${brand?.id}`}
                                value={brand?.id}
                                className="rounded-full"
                                checked={selectedBrands.includes(String(brand?.id))}
                                onCheckedChange={() => handleBrandSelect(Number(brand?.id))}
                            />
                            <label
                                htmlFor={`brand-${brand?.id}`}
                                className="m-2 cursor-pointer flex flex-grow justify-between items-center"
                            >
                                <span>{brand?.title}</span>
                                <span>{brand?.title_latin}</span>
                            </label>
                        </div>
                    );
                })}
                <div ref={lastBrandElementRef} className="min-h-32 w-full flex items-center justify-center">
                    {loading && (
                        <div>
                            <Spinner/>
                        </div>
                    )}

                </div>
            </div>
        </section>
    );
};

export default BrandList;